import { Icon } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Stack, Typography } from '@mui/material';
import { memo } from 'react';
import * as Styled from './styles';
import type { HeaderProps as Props } from './types';

export const Header = memo(({ className }: Props) => {
  return (
    <Styled.Wrapper className={classnames('Header', className)}>
      <Stack direction="row" gap={0.5}>
        <Icon name="receipt" size={20} color="grey.700" />
        <Stack>
          <Typography variant="body4" fontWeight={500} color="grey.600">
            Billing History
          </Typography>
          <Typography variant="body5" fontWeight={400} color="grey.500">
            View and download your past invoice
          </Typography>
        </Stack>
      </Stack>
    </Styled.Wrapper>
  );
});

Header.displayName = 'Header';
